import React from 'react';
import './Header.css';
import OrderImage from './Orders.png';
import OrderBlackImage from './OrdersBlack.png';
import ProfileImage from './profile.png';
import CaretImage from './caret.png';
import IconImage from './Icon.png';
import { useMediaQuery } from 'react-responsive'

const Desktop = ({ children }) => {
    const isNotMobile = useMediaQuery({ minWidth: 376 })
    return isNotMobile ? children : null
}

const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 375 })
    return isMobile ? children : null
  }

export class Header extends React.Component {
    constructor(props) {
        super(props);
        this.parseFirstName = this.parseFirstName.bind(this);
    }

    parseFirstName(name) {
        if(name.length > 0) {
            let pieces = name.split(/[\s,]+/);
            pieces.pop();
            let fName = pieces.join(' ');
            return fName;
        }
    }
    
    render() {
        return(
            <div className = "header">
                <div className = "header-title">
                    <img id = "header-icon" src = {IconImage} alt = "icon"/>
                    <h1> Eatly </h1>
                </div>
                <div className = "header-nav">
                   <Desktop>
                    <div className = "order-button">
                            <img src = {OrderImage} alt = 'orders'/>
                            <p onClick = {this.props.showOrders}> Orders</p> 
                        </div>
                   </Desktop>
                   <Mobile>
                        <div className = "order-button" onClick = {this.props.showOrders}>
                            <img src = {OrderBlackImage} alt = 'orders'/>
                        </div>
                   </Mobile>
                    {/*<div className = "log-out-option">
                        <p>Log Out</p>
        </div>*/}
                </div>
            </div>
        );
    }

}